var map = {
	"./cannon_20_express.png": "ed2a",
	"./cannon_20_regular.png": "5e94",
	"./gamma_3_express.png": "7f66",
	"./gamma_3_regular.png": "1c0f",
	"./infinity_8_express.png": "2f72",
	"./infinity_8_regular.png": "f7e5",
	"./lucky_5_express.png": "0d95",
	"./lucky_5_regular.png": "ceeb",
	"./lucky_7_daily.png": "0d4c",
	"./penta_5_classic.png": "d2ad",
	"./penta_5_express.png": "463b",
	"./penta_5_regular.png": "e4db",
	"./rolling_10_express.png": "0841",
	"./rolling_10_regular.png": "402d",
	"./surfing_10_classic.png": "0b8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a80f";